import { fetchCommentsClientTranslations } from '../../../translations';
export const FETCH_TRANSLATIONS_REQUEST = 'FETCH_TRANSLATIONS_REQUEST';
export const FETCH_TRANSLATIONS_SUCCESS = 'FETCH_TRANSLATIONS_SUCCESS';
export const FETCH_TRANSLATIONS_FAILURE = 'FETCH_TRANSLATIONS_FAILURE';
export const fetchTranslationsRequest = () => ({ type: FETCH_TRANSLATIONS_REQUEST });
export const fetchTranslationsSuccess = (payload) => ({
    type: FETCH_TRANSLATIONS_SUCCESS,
    payload,
});
export const fetchTranslationsFailure = () => ({ type: FETCH_TRANSLATIONS_FAILURE });
export function fetchTranslations(language) {
    return (dispatch, _getState, { httpClient, errorHandler }) => {
        dispatch(fetchTranslationsRequest());
        const loadTranslations = () => fetchCommentsClientTranslations(httpClient, language, errorHandler);
        return loadTranslations().then((body) => dispatch(fetchTranslationsSuccess(body.data)), () => dispatch(fetchTranslationsFailure()));
    };
}
//# sourceMappingURL=translations-actions.js.map